import { createIdentitiesFetcher } from '../contexts/Fetcher';
import { apiRole } from '../resources/api/apiRole';
import { useCallback } from 'react';

const { useListRoles } = apiRole;

export const RolesFetcher = createIdentitiesFetcher(() => {
  const { execute } = useListRoles();
  return useCallback(() => {
    return execute({ page: 1, limit: 1000 });
  }, [execute]);
});
